import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex flex-row-reverse" }

import { computed, reactive, watch } from "vue";
import { useStore } from "vuex";
import VueTableLite from "vue3-table-lite/ts";
import DocumentStatusLabel from "@/components/documents/DocumentStatusLabel.vue";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { DocumentHistoryActions } from "@/store/modules/documentHistory/actions";
import { DocumentHistoryGetters } from "@/store/modules/documentHistory/getters";
import { t } from "@/i18n";
import { formatDateTime } from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  props: {
    documentGuid: null
  },
  setup(__props: any) {

const props = __props as {
  documentGuid?: string | null;
}

const store = useStore();


const normalizedDocumentGuid = computed(() =>
  typeof props.documentGuid === "string" ? props.documentGuid.trim() : ""
);

const dataProvider = computed(() => {
  return store.getters[DocumentHistoryGetters.GET_DATA_PROVIDER];
});
const items = computed(() => {
  return dataProvider.value.items;
});
const pager = computed(() => {
  return dataProvider.value.pager;
});

const getPage = async (page: number) => {
  if (!normalizedDocumentGuid.value) {
    return;
  }

  await store.dispatch(DocumentHistoryActions.FETCH_DATA_PROVIDER, {
    documentGuid: normalizedDocumentGuid.value,
    page: page,
  });
};

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("documentHistory.type"),
      field: "type",
      sortable: false,
    },
    {
      label: t("documentHistory.status"),
      field: "status",
      sortable: false,
    },
    {
      label: t("documentHistory.user"),
      field: "userInfo",
      sortable: false,
    },
    {
      label: t("documentHistory.message"),
      field: "message",
      sortable: false,
    },
    {
      label: t("documentHistory.dateTime"),
      field: "createdAt",
      sortable: false,
    },
  ],
  rows: items,
  totalRecordCount: 0,
});

watch(
  normalizedDocumentGuid,
  async (documentGuid) => {
    if (documentGuid) {
      await getPage(1);
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VueTableLite), {
      "data-pagination-scroll-anchor": "",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      messages: { noDataAvailable: _ctx.$t('common.noData') }
    }, {
      status: _withCtx((data) => [
        _createVNode(DocumentStatusLabel, {
          label: data.value.status
        }, null, 8, ["label"])
      ]),
      createdAt: _withCtx((data) => [
        _createTextVNode(_toDisplayString(_unref(formatDateTime)(data.value.createdAt)), 1)
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ])
  ]))
}
}

})